import type { ErrorType } from '~/data/ErrorRecord';
import type { ErrorResponse } from '~/types/error-responses.types';

export default class BaseException extends Error {
  readonly name: string = 'DIAMException';
  errors: ErrorType[] = [];
  _raw: any;

  constructor(response: ErrorResponse<ErrorType>) {
    super();
    this._raw = response;

    if (response.errors) {
      this.message = response.errors[0]?.description;
      this.errors = response.errors;
    }
  }

  get firstError(): ErrorType {
    return this.errors[0];
  }
}
